import { useEffect, useState } from "react";

import { useT } from "@/3-features/i18n/useT";
import { PATHS } from "@/3-features/navigation/routes";
import { Link } from "@/5-shared/routing";

export function MobileCTA() {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.5);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-visible={visible}
      className="mobile-cta fixed bottom-0 inset-x-0 z-40 xl:hidden translate-y-full data-[visible=true]:translate-y-0 transition-transform duration-300 motion-reduce:transition-none"
    >
      <div className="px-4 py-3 bg-white/90 backdrop-blur border-t border-zinc-200">
        <Link
          to={PATHS.contact}
          className="btn btn-primary w-full justify-center text-sm py-2.5 rounded-full"
        >
          {t("nav.contact")}
        </Link>
      </div>
    </div>
  );
}
